import { useMutation } from '@tanstack/react-query'

import { setAccountingActivation } from '@src/api'
import { DefaultApiSetAccountingActivationRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useSetAccountingActivation = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiSetAccountingActivationRequest) =>
      setAccountingActivation(axiosInstance, params),
  })
}
